import type { SalesChecklistItemDefaultExample } from "@expert/contentful";

import { CarouselWithDefault } from "@/sales-tools/home-product/components/FullOfferChecklist/components/carousels/CarouselWithDefault";
import { useRapportBuildingStore } from "@/sales-tools/rapport-building/useRapportBuildingStore";

export function RapportCarousel({ defaultExample }: { defaultExample: SalesChecklistItemDefaultExample }) {
    const questions = useRapportBuildingStore((state) => state.questions);
    const examples = questions.map((sentences) => {
        return { text: sentences.join(" "), highlights: sentences.at(-1) ? [sentences.at(-1)!] : [] };
    });

    return <CarouselWithDefault defaultExample={defaultExample} examples={examples} />;
}
